import { Component, OnInit } from '@angular/core';
import {GranServicioDePTWService}from '../gran-servicio-de-ptw.service'
import {ServicioLoadersAlertasService} from '../servicio-loaders-alertas.service'
import { AlertController} from '@ionic/angular';
import * as firebase from 'firebase'
import { Router } from '@angular/router';
import {TimelineComponent} from '../timeline/timeline.component'


@Component({
  selector: 'app-paso4page',
  templateUrl: './paso4page.page.html',
  styleUrls: ['./paso4page.page.scss'],
})
export class Paso4pagePage implements OnInit {

  arraydepasos=[{paso:"",consecuencias:"",accion:""}]

  constructor(public granServicioDePTWService:GranServicioDePTWService, public servicioLoadersAlertasService:ServicioLoadersAlertasService, public alertController: AlertController,private router:Router, public timelineComponent:TimelineComponent) { }

  ngOnInit() {}

  agregarPaso(){  
    if(this.arraydepasos==undefined){
      this.arraydepasos=[{paso:"",consecuencias:"",accion:""}]
    }else
    if(this.arraydepasos!=undefined){
      this.arraydepasos.push({paso:"",consecuencias:"",accion:""})
    }
  }

  ionViewWillEnter(){
   
    if(this.granServicioDePTWService.solicitudEsNueva == false){
      this.granServicioDePTWService.cargadatosdePTW((res)=>{
        this.arraydepasos = res.data().arraydepasos
      })
    }

    
  }


  async confirmaBorraPaso(i) {
    const alert = await this.alertController.create({
      header: "¿Eliminar paso?",
      message: "Seguro que desea eliminar este paso?",
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Eliminar',
          handler: () => {
            this.arraydepasos.splice(i,1)
         }
        }
      ]
    });
    await alert.present();
  }


  updateFirebase(){

  firebase.firestore().collection("ptws").doc(this.granServicioDePTWService.idSolicitud).update({
    arraydepasos:this.arraydepasos,
    "objetoPasosCompletados.paso4":"ok"
    }).then((doc)=>{
      this.servicioLoadersAlertasService.presentToast("Actividad y unidad de negocio guardadas. Continúe con el siguiente paso")
      // this.timelineComponent.avanzar('4')
      this.navegar("/paso5page")
    }).catch((err)=>{
      this.servicioLoadersAlertasService.alerta("Error",err);
    })
  }

 
  validaforma(){
    let arraydeNoDiligenciados=[]
    this.arraydepasos.forEach((item,index)=>{
      if(item.accion =='' || item.consecuencias ==''||item.accion==''){
        arraydeNoDiligenciados.push(index)
      }
      if(index == this.arraydepasos.length-1  ){
        if(arraydeNoDiligenciados.length>0){
          this.servicioLoadersAlertasService.alerta("Campos no diligenciados","Existen campos no diligenciados. Asegúrese de diligenciar todos los campos de cada paso")
        }else
        if(arraydeNoDiligenciados.length==0){
          this.updateFirebase()
        }
      }
    })
  }

  navegar(entrada){
    this.router.navigateByUrl(entrada);
 } 

 regresar(){
  this.navegar("/paso3page")
 }

 volveramenu(){
  this.navegar("/menu")
 }



}
